import styled from 'styled-components'
import { safeAreaInset } from '@lib/telegram';

export const Container = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
`

export const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 12px;
  margin-top: 16px;
`

export const MenuItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  margin-top: 8px;
`

export const AlertBoxContainer = styled.div`
  width: 100%;
  display: flex;
  position: absolute;
  bottom: 0;
  padding: 16px 12px 24px 12px;
  padding-bottom: ${safeAreaInset().bottom || 24}px;
`
